import React, { Fragment } from "react";
import { Modal } from "antd";

import "@/styles/components/modal.scss";
import { useDispatch } from "react-redux";
import { setModalOpen } from "@/reducers/commonSlice";

const ModalComponent = ({
  title = null,
  centered = true,
  keyboard = false,
  mask = true,
  maskClosable = true,
  closeIcon = false,
  footer = null,
  width = 531,
  className = "",
  children,
  isOpen = false,
  onCancelClick = () => {},
  ...rest
}) => {
  const dispatch = useDispatch();
  const handleCancel = () => {
    onCancelClick();
    dispatch(setModalOpen(false));
  };
  return (
    <Fragment>
      <Modal
        title={title}
        centered={centered}
        keyboard={keyboard}
        mask={mask}
        maskClosable={maskClosable}
        closeIcon={closeIcon}
        footer={footer}
        width={width}
        className={className}
        open={isOpen}
        onCancel={handleCancel}
        {...rest}
      >
        {children}
      </Modal>
    </Fragment>
  );
};

export default ModalComponent;
